import { safeSelect } from '../../utils/object/safeSelect.ts';
import { getStore } from '../store/getStore.ts';
import type { ReduxSelector, ReduxState } from '../types';

export function createSelector<T, R = T, State extends object = ReduxState>(pathOrPaths: string | string[], defaultValue: T): ReduxSelector<R, State>;
export function createSelector<T, R = T, State extends object = ReduxState>(
  pathOrPaths: string | string[], defaultValue?: T, mapper?: (v: T) => R | undefined): ReduxSelector<R, State>;

// @FUTURE Come up with a way to have a more type-safe state object.

/**
 * Creates a selector for the given path or paths.
 * When executed, it will return the value of the first path with a non-falsy value.
 */
export function createSelector<T, R = T, State extends object = ReduxState>(
  pathOrPaths: string | string[], defaultValue?: T, mapper?: (v: T) => R): ReduxSelector<R, State> {
  return (state = getStore().getState()) => {
    let value: T | undefined = undefined;

    for (const path of Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths]) {
      value = safeSelect(state, path) as T;

      if (value !== undefined) break;
    }

    value ??= defaultValue;

    return mapper && value !== undefined
      ? mapper(value)
      : value as R;
  }
}